import { IDataHandler } from '../IDataHandler';
import { ResourceTrackingEventName } from '../TrackingEvent';
import { ResourceDataSet } from '../DataSet/Resource';

const ResourceDataMap: {
    [key in ResourceTrackingEventName]: (keyof ResourceDataSet)[];
} = {
    [ResourceTrackingEventName.resource]: [
        'tChangerReceived',
        'tChangerUsed',
        'tChangerCoins',
        'tRemoveOneReceived',
        'tRemoveOneUsed',
        'tRemoveOneCoins',
        'tMassRemoveReceived',
        'tMassRemoveUsed',
        'tMassRemoveCoins',
        'tFreeEntryReceived',
        'tFreeEntryUsed',
        'tPlus5Received',
        'tPlus5Used',
        'tJokerReceived',
        'tJokerUsed',
        'tJokerCoins',
        'tUndoReceived',
        'tUndoUsed',
        'tUndoCoins',
        'tCoinsReceived',
        'tCoinsUsed',
        'tExtraCardsReceived',
        'tExtraCardsCoins',
        'tRemoveCardsBoostersReceived',
        'tRemoveCardsBoostersUsed',
        'tRemoveCardsBoostersCoins',
        'tExtraWildcardsBoostersReceived',
        'tExtraWildcardsBoostersUsed',
        'tExtraWildcardsBoostersCoins',
        'tCanisterCardBoostersReceived',
        'tCanisterCardBoostersUsed',
        'tCanisterCardBoostersCoins',
        'tHelperCards',
        'socialActionType',
        'socialSend',
        'socialRecieve',
        'tStarChestType',
        'tQuestName',
        'tQuestID',
        'tQuestTier'
    ],
};

export class ResourceDataHandler implements IDataHandler<ResourceDataSet> {
    public data = new ResourceDataSet();

    public getEventData(eventName: ResourceTrackingEventName): ResourceDataSet {
        const result = {} as ResourceDataSet;
        ResourceDataMap[eventName].forEach(key => {
            // @ts-ignore TS2322: Type number | TSocialActionType is not assignable to type never
            result[key] = this.data[key];
        });

        // Reset data.
        if (eventName === ResourceTrackingEventName.resource) {
            this.clearData();
        }

        return result;
    }

    public clearData(): void {
        this.data = new ResourceDataSet();
    }
}
